import type { CSSProperties } from 'react';

import type { AddressSuggestion } from '../api/address-suggestions';
import type { SuggestionStatus } from '../hooks/use-address-suggestions';

import { suggestionNote } from './use-address-autocomplete';

const LIST_STYLE: CSSProperties = {
  position: 'absolute',
  zIndex: 20,
  top: 'calc(100% + 2px)',
  left: 0,
  right: 0,
  margin: 0,
  padding: 4,
  listStyle: 'none',
  maxHeight: 220,
  overflowY: 'auto',
  background: 'var(--nb-bg)',
  border: '1px solid var(--nb-border-2)',
  borderRadius: 8,
  boxShadow: 'var(--nb-shadow-md)',
};

const NOTE_STYLE: CSSProperties = { padding: '6px 8px', fontSize: 12, color: 'var(--nb-subtle)' };

export function AddressSuggestionList({
  id,
  suggestions,
  active,
  status,
  onPick,
}: {
  id: string;
  suggestions: AddressSuggestion[];
  active: number;
  status: SuggestionStatus;
  onPick: (address: AddressSuggestion) => void;
}) {
  const note = suggestionNote(status, suggestions.length);
  return (
    <ul id={id} role="listbox" aria-label="Address suggestions" style={LIST_STYLE}>
      {note && (
        <li role="presentation" style={NOTE_STYLE}>
          {note}
        </li>
      )}
      {suggestions.map((s, i) => (
        <li
          key={s.id}
          id={`${id}-${i}`}
          role="option"
          aria-selected={i === active}
          onMouseDown={(e) => {
            e.preventDefault();
            onPick(s);
          }}
          style={{
            padding: '6px 8px',
            fontSize: 12.5,
            borderRadius: 6,
            cursor: 'pointer',
            color: 'var(--nb-ink)',
            background: i === active ? 'var(--nb-primary-soft)' : 'transparent',
          }}
        >
          {s.label}
        </li>
      ))}
    </ul>
  );
}
